const locale = {
  month: 'mo',
  day: 'd',
  hour: 'h'
};
export default locale;